import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { StatsComponent } from './components/stats/stats.component';
import { CircleComponent } from './components/stats/circle/circle.component';
import { TitleComponent } from './components/stats/title/title.component';
import { ColumnComponent } from './components/column/column.component';
import { RowComponent } from './components/row/row.component';
import { ArrowsComponent } from './components/stats/arrows/arrows.component';
import { TableColumnComponent } from './components/table-column/table-column.component';
import { TableComponent } from './components/table-column/table/table.component';
import { ServicesRowComponent } from './components/table-column/services-row/services-row.component';
import { ServiceComponent } from './components/table-column/services-row/service/service.component';
import { CommaToDotPipe } from './pipes/comma-to-dot.pipe';
import { ChartsComponent } from './components/charts/charts.component';
import { ChartComponent } from './components/charts/chart/chart.component';
import { ErrorsComponent } from './components/stats/errors/errors.component';
import { Colors } from './models/enums/colors.enum';
import { DragScrollModule } from 'ngx-drag-scroll';
import { MapChartComponent } from './components/charts/chart/map-chart/map-chart.component';
import { HttpService } from './services/http.service';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { ErrorNoticeService } from './services/error-notice.service';

@NgModule({
  declarations: [
    AppComponent,
    StatsComponent,
    CircleComponent,
    TitleComponent,
    ColumnComponent,
    RowComponent,
    ArrowsComponent,
    TableColumnComponent,
    TableComponent,
    ServicesRowComponent,
    ServiceComponent,
    CommaToDotPipe,
    ChartsComponent,
    ChartComponent,
    ErrorsComponent,
    MapChartComponent,
    DateFormatPipe,
  ],
  imports: [
    BrowserModule,
    DragScrollModule,
    BrowserAnimationsModule,
  ],
  providers: [
    HttpService,
    ErrorNoticeService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts